<template>
  <div>
    <div class="vld-parent">
      <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="fullPage"></loading>
    </div>
    <b-modal ref="modal" title="" @hidden="resetModal()" cancel-variant="transparent" scrollable size="lg">
      <template #modal-title>
        <h4 class="mt-2 pb-0">Nova transcrição</h4>
      </template>
      <div>
        <b-form v-if="showTranscriptionTab">
          <b-form-group class="tab-bold" label="Nome da transcrição" label-for="name-input"
            :state="transcriptionNameState" :invalid-feedback="transcriptionNameInvalidFeedback">
            <b-form-input :state="transcriptionNameState" id="name-input" v-model="transcription.name"></b-form-input>
          </b-form-group>
          <b-form-group class="tab-bold" label="Descrição da transcrição" label-for="monitor-description">
            <b-form-input id="monitor-description" v-model="transcription.description"></b-form-input>
          </b-form-group>

          <b-form-group :state="fileState" invalid-feedback="É necessário selecionar um arquivo válido">
            <b-form-file v-model="file" :state="fileState" :placeholder="fileName"
              accept=".wav, .mp3, .m4a, .wma, .flac, .ogg, .mp4, .avi" browse-text="Escolha o arquivo"
              @input="changeFile()">
            </b-form-file>
          </b-form-group>

          <div>
            <b-form v-if="isMultiChannel(true) && !isVideo" inline>
              <b-form-checkbox class="multichannelAudio mt-4" value="accepted" v-model="multiChannelChecked"
                unchecked-value="not_accepted" @change="onChangeMultiChannelCheckBox($event)">
                Áudio multicanal
              </b-form-checkbox>
              <img src="@/assets/icons/icone_i.svg" v-b-tooltip.hover.right :title="multiChannelAudioInformation"
                ref="showAfterFile" style="margin-top: 5px; margin-left: 8px;" />
            </b-form>
            <b-form v-else-if="isMultiChannel(false) && !isVideo && isDiarization()" inline>
              <div class="diarization-container">
                <b-form-checkbox class="diarizationCheckbox" v-model="transcription.diarization"
                  @change="onChangeDiarizationCheckbox($event)">
                  Diarização
                </b-form-checkbox>

                <div v-if="transcription.diarization" class="diarization-inputs">
                  <span class="speakers-label">Locutores:</span>
                  <b-form-input id="diarization-input" v-model="transcription.diarizationSpeakers" type="number" min="1"
                    max="8" @keydown="validateInput($event)" @change="onChangeDiarizationValue($event)">
                  </b-form-input>
                  <img src="@/assets/icons/icone_i.svg" v-b-tooltip.hover.right :title="diarizationAudioInformation"
                    ref="showAfterFile" class="info-icon" />
                </div>
              </div>
            </b-form>
          </div>
        </b-form>
        <b-form class="multiChannel" v-if="!showTranscriptionTab">
          <b-form-group class="tab mt-4">
            <p class="aboutAccuracy">Canais de áudio (multicanal)</p>
            <div v-for="(item, index) in audioChannelCount" :key="index">
              <b-form inline>
                <b-button :style="channelStyle(item.channel)" disabled>{{ item.channel }}</b-button>
                <b-form-input type="text" style="margin-top: -5px;" v-model="audioChannelCount[index].announcer"
                  :placeholder=item.announcer class="channels"></b-form-input>
              </b-form>
              <br>
            </div>
          </b-form-group>
        </b-form>
        <b-form>
          <div v-show="file != null">
            <b-progress height="13px" style="background-color: #DEF1FF; margin-top: 15px"
              :value="this.$store.state.transcription.percentCompleted" show-progress class="mb-2"></b-progress>
            <img :src="imgStatusAccuracy" />
            <p class="tab" style="margin-top: 15px; margin-left: 10px; display: inline-block; line-height: 20px">
              Potencial de
              <span style="font-weight: bold">{{ accuracyStatus }}</span>
            </p>
            <p class="tab" style="display: inline-block; font-size: 14px; margin-left: 275px">Duração: <span
                style="font-weight: bold"> {{ formatedFileDuration }}</span></p>
            <div>
              <b-link @click="onKnowMoreClick()" class="knowMore">Saber mais</b-link>
              <img src="@/assets/icons/arrow.svg" style="margin-left: 5px" />
            </div>
          </div>
        </b-form>
      </div>
      <template v-slot:modal-footer>
        <b-button class="btn-secondary btn-transparent" @click="onButtonBackActionClick()">{{ btnBackAction
          }}</b-button>
        <b-button type="button" @click="onButtonNextActionClick()" class="btn-primary"
          style="width: 134px; margin-right: 10px;">{{ btnNextAction }}</b-button>
      </template>
    </b-modal>
    <b-modal class="body" ref="accuracyModal" :ok-title="submitTitle" cancel-title="Cancelar"
      cancel-variant="transparent" @ok="handleModalOk" hide-footer>
      <h4 class="ml-0">Conte-nos sobre o que você deseja transcrever:</h4>
      <b-form-group class="tab">
        <b-form-checkbox v-for="option in options" @change="onAccuracySelectedChange(event)" v-model="selecteds"
          :key="option.value" :value="option.value">
          {{ option.text }}
        </b-form-checkbox>
        <img :src="imgStatusAccuracy" />
        <p class="" style="margin-top: 15px; margin-left: 10px; display: inline-block; line-height: 20px">Potencial de
          <span style="font-weight: bold">{{ accuracyStatus }}</span>
        </p>
        <p class="aboutAccuracy mt-4">Saiba mais sobre o assunto em <a :href="site"
            target="blanc">www.digitro.com/retextoar/</a>
        </p>
      </b-form-group>
      <footer>
        <b-button class="btn-primary btn-close" @click="hideAcurracyModal()">Voltar a transcrição</b-button>
      </footer>
    </b-modal>
  </div>
</template>

<script>
  import { formatingSecondToDate } from '../../helpers';
  import alertTriangle from '@/assets/icons/alert-triangle.svg';
  import doneIcon from '@/assets/icons/done.svg';
  import { userService } from '../../services/user_service';
  import { transcriptionService } from '../../services/transcription.service';
  import Loading from 'vue-loading-overlay';

  export default {
    components: {
      Loading
    },
    data () {
      return {
        alertTriangle,
        doneIcon,
        modalTitle: 'Nova transcrição',
        imgStatusAccuracy: alertTriangle,
        metadata: [],
        file: null,
        fileState: null,
        allowedExtensions: ['.wav', '.mp3', '.m4a', '.wma', '.flac', '.ogg', '.mp4', '.avi'],
        transcriptionNameInvalidFeedback: 'Nome é necessário',
        isLoading: false,
        formatedFileDuration: '00:00:00',
        isMultichannel: null,
        audioDuration: 0,
        isVideo: false,
        audioChannelCount: [],
        diarizationPermission: null,
        transcriptionNameState: null,
        accuracyStatus: 'baixa acuracidade',
        multiChannelChecked: 'not_accepted',
        showTranscriptionTab: true,
        progressValue: 0,
        submitTitle: 'Ok',
        fileName: 'Sem arquivo de fonte',
        site: 'https://www.digitro.com/retextoar',
        selecteds: [],
        fullPage: true,
        transcription: {
          name: '',
          description: '',
          inputFile: '',
          diarization: false,
          diarizationSpeakers: ''
        },
        options: [
          { text: 'O áudio está sem ruído?', value: 'withoutNoise' },
          { text: 'Os locutores estão próximos ao microfone?', value: 'nextEachOther' },
          { text: 'Os locutores falam um de cada vez?', value: 'oneAtTime' },
          { text: 'Os locutores falam claramente?', value: 'clearly' }
        ],
        multiChannelAudioInformation: 'Selecione essa opção caso seu áudio possua múltiplas fontes de som, independentes entre sí. Caso tenha dúvidas sobre o tipo de áudio, não selecione a opção. Mais informações em retextoar.com.br',
        diarizationAudioInformation: 'Você pode informar a quantidade de locutores do áudio para que o sistema realize a separação na transcrição ou deixar vazio para o processo ser automático. É possível especificar entre 1 e 8 locutores.',
        announcer1: 'Locutor 01',
        announcer2: 'Locutor 02',
        announcer3: 'Locutor 03',
        btnNextAction: 'Transcrever',
        btnBackAction: 'Fechar'
      };
    },
    created () {
      this.formatedFileDuration = '00:00:00';
    },
    methods: {
      isMultiChannel (boolean) {
        return this.isMultichannel === boolean;
      },
      isDiarization () {
        console.log(this.$store.state.account.permissions);
        const isDiarization = this.$store.state.account.permissions.includes('DIARIZACAO');
        return isDiarization;
      },
      onChangeDiarizationCheckbox (checked) {
        this.transcription.diarization = checked;
        if (!checked) {
          this.transcription.diarizationSpeakers = '';
          this.changeButtons(false);
        }
      },
      checkFormValidity () {
        this.transcriptionNameState = this.transcription.name.length >= 4;
        if (this.transcription.name.length < 4) {
          this.transcriptionNameInvalidFeedback = 'Mínimo de 4 caracteres';
        } else {
          this.transcriptionNameInvalidFeedback = 'Nome é necessário';
        }
        return this.transcriptionNameState && this.file;
      },
      validateInput (event) {
        const isNumberPattern = /^[1-8]+$/;
        const isNotNumber = !isNumberPattern.test(event.key);
        const permittedKeysCondition = event.key !== 'Backspace' && event.key !== 'Delete' && event.key !== 'ArrowLeft' && event.key !== 'ArrowRight';
        if (isNotNumber && permittedKeysCondition) {
          event.preventDefault();
        }
        if (this.transcription.diarization.length === 1 && permittedKeysCondition) {
          event.preventDefault();
        }
      },
      handleModalOk (bvModalEvt) {
        this.handleSubmit();
      },
      async handleSubmit (e) {
        this.submitted = true;
        if (!this.checkFormValidity()) {
          return;
        } else if (Number(this.audioDuration) <= 0) {
          this.$toast.open({ message: 'Não foi possivel identificar a mídia!', type: 'error' });
          return;
        }

        const balance = await userService.creditsInfo();
        const preferences = await userService.preferences();
        const editorOptions = preferences.editorOptions;
        if (balance) {
          const creditsTotal = Number(balance.credits);
          const reservedCredits = Number(balance.reservado);
          const creditsAvailable = creditsTotal - reservedCredits;
          if (creditsAvailable >= Number(this.audioDuration)) {
            const newTranscription = {
              name: this.transcription.name,
              description: this.transcription.description,
              duration: this.audioDuration,
              type: 'automatic',
              numOfSpeakers: 1,
              multiChannel: false
            };
            if (this.multiChannelChecked === 'accepted') {
              newTranscription.multiChannel = true;
              const channels = [];
              for (const item of this.audioChannelCount) {
                channels.push({ _id: item.channel - 1, name: item.announcer });
              }
              newTranscription.channels = channels;
            } else if (this.transcription.diarization) {
              newTranscription.diarization = true;
              if (this.transcription.diarizationSpeakers !== null && this.transcription.diarizationSpeakers !== '') {
                newTranscription.numOfSpeakers = Number(this.transcription.diarizationSpeakers);
                const channels = [];
                for (const item of this.audioChannelCount) {
                  channels.push({ _id: item.channel - 1, name: item.announcer });
                }
                newTranscription.channels = channels;
              }
            }
            if (editorOptions.showNumbers) {
              newTranscription.normalizer = true;
            }
            this.isLoading = true;
            try {
              const res = await transcriptionService.registerTranscription(newTranscription);
              if (res.status === 402) {
                this.$toast.open({ message: 'Créditos insuficientes!', type: 'warning' });
                this.isLoading = false;
                this.$nextTick(() => {
                  this.$refs.modal.hide();
                });
                this.resetModal();
                return;
              }
              const transcriptionInfo = await res.json();
              const valId = res.headers.get('x-val-id');

              await transcriptionService.uploadMedia(transcriptionInfo.id, this.file, valId);
            } catch (error) {
              this.isLoading = false;
              console.log(error);
              this.$toast.open({ message: error.statusText, type: 'error' });
              return;
            }

            this.$toast.open('Transcrição enviada com sucesso!');
            this.isLoading = false;

            this.$emit('loadTranscripts', { perPage: 15, currentPage: 1 });
            this.$store.state.transcription.percentCompleted = 0;
            this.$nextTick(() => {
              this.$refs.modal.hide();
            });
            this.resetModal();
          } else {
            this.resetModal();
            this.$toast.open({ message: 'Créditos insuficientes!', type: 'warning' });
          }
        }
      },
      async getFileDuration () {
        this.isLoading = true;
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          const audio = document.createElement('audio');
          if (this.file.type.includes('video')) {
            this.isVideo = true;
          }
          reader.onload = (e) => {
            audio.src = e.target.result;
            const audioCtx = new AudioContext();
            audioCtx.decodeAudioData(e.target.result)
              .then((buffer) => {
                console.log(`detected ${buffer.numberOfChannels} audio channels in the selected file`);
                console.log(`duration of audio: ${buffer.duration}`);
                if (buffer.numberOfChannels > 1) {
                  this.addAnnouncers(buffer.numberOfChannels);
                }
                this.audioDuration = parseInt(buffer.duration);
                this.isLoading = false;
                resolve();
              })
              .catch((error) => {
                console.error('Error decoding audio data:', error);
                this.isLoading = false;
                reject(error);
              });
          };
          reader.onerror = (error) => {
            this.isLoading = false;
            reject(error);
          };
          reader.readAsArrayBuffer(this.file);
        });
      },
      async changeFile () {
        if (!this.file) {
          this.isLoading = false;
          return;
        }

        const fileName = this.file.name.toLowerCase();
        const isValid = this.allowedExtensions.some((ext) => fileName.endsWith(ext));

        if (!isValid) {
          this.file = null;
          this.fileState = false;
          return;
        } else {
          this.fileState = true;
        }

        this.isVideo = false;
        this.multiChannelChecked = 'not_accepted';
        this.transcription.diarization = false;
        this.transcription.diarizationSpeakers = '';
        this.audioChannelCount = [];
        this.changeButtons(false);

        try {
          await this.getFileDuration();
          this.updateFileDuration();
          if (this.audioChannelCount.length > 1) {
            this.isMultichannel = true;
          } else {
            this.isMultichannel = false;
          }
        } catch (error) {
          this.$toast.open({ message: 'Erro ao processar o arquivo!', type: 'error' });
          this.file = null;
          this.fileState = false;
        }
      },
      onKnowMoreClick () {
        this.$refs.accuracyModal.show();
      },
      async onButtonBackActionClick () {
        if (this.showTranscriptionTab) {
          await this.hideModal();
        } else if (this.multiChannelChecked === 'accepted' || (this.transcription.diarization !== '' && this.transcription.diarization !== null)) {
          this.fileName = this.file.name;
          this.showTranscriptionTab = true;
          this.btnNextAction = 'Avançar';
          this.btnBackAction = 'Fechar';
        }
      },
      channelStyle (channelId) {
        let style = '';
        const colors = ['#EC7532', '#0FD5DB', '#160FDB', '#C3272E', '#4D0DEB', '#27600A', '#C95E01', '#37A658'];
        style = `letter-spacing: 4px; background-color: ${colors[channelId - 1]}; border: none; width: 40px; margin-top: -5px;`;
        return style;
      },
      async hideAcurracyModal () {
        this.$refs.accuracyModal.hide();
      },
      async hideModal () {
        this.$nextTick(() => {
          this.$refs.modal.hide();
        });
      },
      async onAccuracySelectedChange () {
        if (this.selecteds.length === 4) {
          this.accuracyStatus = 'alta acuracidade';
          this.imgStatusAccuracy = this.doneIcon;
        } else {
          this.accuracyStatus = 'baixa acuracidade';
          this.imgStatusAccuracy = this.alertTriangle;
        }
      },
      showModal () {
        this.$refs.modal.show();
      },
      resetModal () {
        this.transcription.name = '';
        this.transcription.description = '';
        this.transcription.diarization = false;
        this.transcription.diarizationSpeakers = '';
        this.transcriptionNameState = null;
        this.$emit('startTimer');
        this.$store.state.transcription.percentCompleted = 0;
        this.isMultichannel = null;
        this.audioChannelCount = [];
        this.showTranscriptionTab = true;
        this.multiChannelChecked = 'not_accepted';
        this.changeButtons(false);
      },
      async goToNextPg () {
        this.showTranscriptionTab = false;
        this.btnNextAction = 'Transcrever';
        this.btnBackAction = 'Voltar';
      },
      updateFileDuration () {
        this.formatedFileDuration = formatingSecondToDate(this.audioDuration);
      },
      changeButtons (condition) {
        if (condition) {
          this.btnNextAction = 'Avançar';
        } else {
          this.btnNextAction = 'Transcrever';
        }
        this.btnBackAction = 'Fechar';
      },
      onChangeMultiChannelCheckBox (checked) {
        const condition = checked === 'accepted';
        this.changeButtons(condition);
      },
      onChangeDiarizationValue () {
        const condition = this.transcription.diarization &&
          this.transcription.diarizationSpeakers !== null &&
          this.transcription.diarizationSpeakers !== '';
        this.changeButtons(condition);
      },
      addAnnouncers (numberOfChannels) {
        this.audioChannelCount = [];
        for (let i = 1; i <= numberOfChannels; i++) {
          this.audioChannelCount.push({ channel: i, announcer: `Locutor ${i}` });
        }
      },
      async onButtonNextActionClick () {
        const diarizationValidate = this.transcription.diarization &&
          this.transcription.diarizationSpeakers !== null &&
          this.transcription.diarizationSpeakers !== '' &&
          this.showTranscriptionTab;
        const multiChannelCheckedValidate = this.multiChannelChecked === 'accepted' && this.showTranscriptionTab;

        if (diarizationValidate) {
          const diarizationInt = Number(this.transcription.diarizationSpeakers);
          this.addAnnouncers(diarizationInt);
        }

        if (diarizationValidate || multiChannelCheckedValidate) {
          if (!this.checkFormValidity()) {
            return;
          }
          await this.goToNextPg();
        } else {
          await this.handleModalOk();
        }
      }
    },
    watch: {
      'transcription.name' () {
        this.transcriptionNameState = this.transcription.name.length >= 4;
      },
      'transcription.diarizationSpeakers' () {
        this.onChangeDiarizationValue();
      }
    }
  };
</script>

<style lang="scss" scoped>
    .aboutAccuracy {
        line-height: 18px;
        font-size: 16px;
        font-weight: bold;
        font-family: Poppins;
        margin-bottom: 25px;
        margin-top: -10px;
    }
    h4 {
        padding-bottom: 18px;
    }
    footer {
        text-align: right;
        margin-right: 25px;
        margin-bottom: 15px;
    }
    .multichannelAudio {
        color: #6278A3;
        font-size: 16px;
        font-family: Poppins;
    }
    .form-control {
        font-weight: 400;
        font-family: Poppins;
    }

    ::-moz-placeholder {  /* Firefox 19+ */
        color: #6278A3;
    }

    .bv-no-focus-ring {
        font-weight: 400;
        font-family: Poppins;
        font-size: 16px;
        line-height: 25px;
    }
    .channels {
        font-size:14px;
        height: 36px;
        margin-left: 10px;
        width: 675px !important;
        border-radius: 3px;
    }
    .nav-item > li{
        border: none !important;
    }
    .knowMore {
        color: #207BDD;
        font-weight: 200;
        font-size: 16px;
        font-family: Poppins;
        margin-left: 30px;
        font-size: 14px
    }
    .tab-bold {
        color: #6278A3;
        font-weight: 600;
        font-size: 16px;
        font-family: Poppins;
        margin-bottom: 25px;
        margin-top: -10px;
    }
    .tab {
        color: #6278A3;
        font-size: 16px;
        font-family: Poppins;
    }
    .btn-close {
        width: 190px !important;
        min-height: 10px !important;
    }
    .btn-primary {
        background-color: #207BDD;
        border:none;
        width: 134px;
        margin-right: -15px;
        height: 44px;
        margin-top: 15px;
    }
    .btn-transparent {
        background-color: #EBEFF2;
        color: #6278A3;
        font-family: 'Poppins';
        font-weight: 600;
        border: none;
        width: 134px;
        margin-right: 20px;
        height: 44px;
        margin-top: 15px;
    }

    /deep/.modal-body .multiChannel {
      margin-top: -25px;
      height: 40%;
    }
    /deep/.modal-header {
      margin-bottom: -15px
    }

    /deep/.modal-header .close {
        display:none !important;
        padding: none !important;
    }
    /deep/.modal-footer {
      margin-top: -20px;
    }
  .diarization-container {
    display: flex;
    align-items: center;
    margin-top: 1rem;
  }

  .diarizationCheckbox {
    color: #6278A3;
    font-size: 16px;
    font-family: Poppins;
    margin-right: 20px;
    margin-bottom: 0 !important;
  }

  .diarization-inputs {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 9px;
  }

  .speakers-label {
    color: #6278A3;
    font-size: 16px;
    font-family: Poppins;
    white-space: nowrap;
  }

  #diarization-input {
    font-size: 17px;
    line-height: 20px;
    height: 30px;
    width: 84px !important;
    border-radius: 2px;
    margin: 0;
  }

  .info-icon {
    margin: 0;
    cursor: pointer;
  }
</style>
